module.exports = __webpack_public_path__ + "img/avatar.2dd1ad08.svg";